export default "__VITE_ASSET__SfU30Yio__"